import { useEffect, useState } from 'react'
import './home-page.styles.scss';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { listenToMyLeagues } from '@/utils/getDataFromDb';
import Loader from '@/components/loader/loader.comp';
import ManagerLeague from '@/components/HOME/manager-league/manager-league.component';

const LAST_LEAGUE_KEY = 'b618-last-league';

// /home sends you to your team: the league you last opened, your only
// league, or the league list if you haven't joined one.
// /home/:leagueId/* is your team's area in one league.
const HomePage = () => {
    return (
        <Routes>
            <Route path='' element={<HomeRedirect />}></Route>
            <Route path=':leagueId/*' element={<ManagerLeague onOpen={rememberLeague} />}></Route>
        </Routes>
    )
}

const HomeRedirect = () => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const [ myLeagues, setMyLeagues ] = useState(null);

    useEffect(() => {
        if (!userProfile?.appId) return;
        let unsub;
        listenToMyLeagues({
            'appId': userProfile.appId,
            'callback': setMyLeagues,
            'handleListener': (u) => { unsub = u; },
        });
        return () => { if (unsub) unsub(); }
    }, [userProfile])

    if (!myLeagues) return <div className='home-loading'><Loader /></div>;
    const ids = Object.keys(myLeagues);
    if (ids.length === 0) return <Navigate replace to='/leagues' />;
    const last = readLastLeague();
    const target = ids.includes(last) ? last : ids.length === 1 ? ids[0] : null;
    return <Navigate replace to={target ? `/home/${target}` : '/leagues'} />;
}

// Remembered per browser only, so storage failures just mean no shortcut.
function rememberLeague(leagueId) {
    try { localStorage.setItem(LAST_LEAGUE_KEY, leagueId); } catch { /* ignore */ }
}

function readLastLeague() {
    try { return localStorage.getItem(LAST_LEAGUE_KEY); } catch { return null; }
}

export default HomePage
